(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.QCatalogSearchSession = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  var VERSION = 1;
  var MAX_SNAPSHOT = 32 * 1024 * 1024;
  var MAX_TOTAL = 64 * 1024 * 1024;
  var MAX_COUNT = 4;
  function uuid() {
    if (globalThis.crypto && globalThis.crypto.randomUUID) return globalThis.crypto.randomUUID();
    throw new Error('Secure random UUID unavailable');
  }
  function validate(pages) {
    if (!Array.isArray(pages) || !pages.length) return false;
    var ids = new Set(); var handles = new Set();
    var pageWidth = pages[0] && Array.isArray(pages[0].products) ? pages[0].products.length : 0;
    if (pageWidth > 248 || (pages.length > 1 && pageWidth === 0)) return false;
    for (var i = 0; i < pages.length; i++) {
      var entry = pages[i];
      if (!entry || entry.page !== i + 1 || !Array.isArray(entry.products) || entry.reachedEnd !== (i === pages.length - 1)) return false;
      if (i < pages.length - 1 && entry.products.length !== pageWidth) return false;
      if (i === pages.length - 1 && entry.products.length >= pageWidth && pages.length > 1) return false;
      for (var j = 0; j < entry.products.length; j++) {
        var product = entry.products[j];
        if (!product || !product.id || !product.handle || !product.q_metafields || typeof product.q_metafields !== 'object') return false;
        if (ids.has(String(product.id)) || handles.has(product.handle)) return false;
        ids.add(String(product.id)); handles.add(product.handle);
      }
    }
    return true;
  }
  function selectFields(source, names) {
    var selected = {};
    names.forEach(function (name) {
      if (source && Object.prototype.hasOwnProperty.call(source, name)) selected[name] = source[name];
    });
    return selected;
  }
  function compactImage(value) {
    if (typeof value === 'string') return value;
    if (!value || typeof value !== 'object') return value;
    return selectFields(value, ['src', 'url']);
  }
  function compactProduct(product) {
    // Keep every field read by the theme's parser, search, filters, cards and Ajax refresh.
    var result = selectFields(product, [
      'id', 'handle', 'title', 'type', 'product_type', 'tags', 'available',
      'price', 'price_min', 'url', 'q_metafields', 'metafields', 'updated_at'
    ]);
    if (Object.prototype.hasOwnProperty.call(product, 'image')) result.image = compactImage(product.image);
    if (Object.prototype.hasOwnProperty.call(product, 'featured_image')) result.featured_image = compactImage(product.featured_image);
    if (Array.isArray(product.images)) result.images = product.images.length ? [compactImage(product.images[0])] : [];
    if (Array.isArray(product.variants)) result.variants = product.variants.map(function (variant) {
      var selected = selectFields(variant, ['id', 'title', 'name', 'price', 'compare_at_price', 'available']);
      if (Object.prototype.hasOwnProperty.call(variant, 'featured_image')) selected.featured_image = compactImage(variant.featured_image);
      if (Object.prototype.hasOwnProperty.call(variant, 'image')) selected.image = compactImage(variant.image);
      return selected;
    });
    return result;
  }
  function compactPage(entry) {
    return { page: entry.page, products: entry.products.map(compactProduct), reachedEnd: entry.reachedEnd };
  }
  function memoryAdapter() {
    var manifests = new Map(); var pages = new Map();
    return {
      readManifest: async function (slot) { return manifests.get(slot) || null; },
      readPage: async function (slot, generation, page) { var row = pages.get(slot + '|' + generation + '|' + page); return row ? row.value : null; },
      writePage: async function (slot, generation, page, value) { pages.set(slot + '|' + generation + '|' + page, { value: value, createdAt: Date.now() }); },
      commitManifest: async function (slot, expected, manifest) {
        var current = manifests.get(slot);
        if ((current ? current.generation : null) !== (expected || null)) return false;
        manifests.set(slot, manifest); return true;
      },
      listManifests: async function () { return Array.from(manifests.entries()).map(function (entry) { return { slot: entry[0], manifest: entry[1] }; }); },
      deleteGeneration: async function (slot, generation) { Array.from(pages.keys()).filter(function (key) { return key.startsWith(slot + '|' + generation + '|'); }).forEach(function (key) { pages.delete(key); }); },
      deleteManifest: async function (slot, generation) { if (manifests.get(slot) && manifests.get(slot).generation === generation) manifests.delete(slot); },
      cleanupOrphans: async function (cutoff) {
        pages.forEach(function (row, pageKey) {
          var live = Array.from(manifests.entries()).some(function (entry) { return pageKey.startsWith(entry[0] + '|' + entry[1].generation + '|'); });
          if (!live && row.createdAt < cutoff) pages.delete(pageKey);
        });
      },
      close: function () {}
    };
  }
  function idbAdapter(indexedDB) {
    var database = null;
    function requestResult(request) { return new Promise(function (resolve, reject) { request.onsuccess = function () { resolve(request.result); }; request.onerror = function () { reject(request.error); }; }); }
    function transactionDone(tx) { return new Promise(function (resolve, reject) { tx.oncomplete = resolve; tx.onabort = tx.onerror = function () { reject(tx.error || new Error('IndexedDB transaction failed')); }; }); }
    function open() {
      if (database) return database;
      database = new Promise(function (resolve, reject) {
        var request = indexedDB.open('q-catalog-search', VERSION);
        request.onupgradeneeded = function () {
          var db = request.result;
          if (!db.objectStoreNames.contains('manifests')) db.createObjectStore('manifests', { keyPath: 'slot' });
          if (!db.objectStoreNames.contains('pages')) db.createObjectStore('pages', { keyPath: 'key' });
        };
        request.onsuccess = function () { resolve(request.result); };
        request.onerror = function () { reject(request.error); };
      });
      return database;
    }
    async function read(storeName, key) {
      var db = await open(); var tx = db.transaction(storeName, 'readonly');
      var result = await requestResult(tx.objectStore(storeName).get(key));
      await transactionDone(tx); return result || null;
    }
    return {
      readManifest: async function (slot) { var row = await read('manifests', slot); return row && row.manifest; },
      readPage: async function (slot, generation, page) { var row = await read('pages', slot + '|' + generation + '|' + page); return row && row.value; },
      writePage: async function (slot, generation, page, value) {
        var db = await open(); var tx = db.transaction('pages', 'readwrite');
        tx.objectStore('pages').put({ key: slot + '|' + generation + '|' + page, slot: slot, generation: generation, page: page, value: value, createdAt: Date.now() });
        await transactionDone(tx);
      },
      commitManifest: async function (slot, expected, manifest) {
        var db = await open(); var tx = db.transaction('manifests', 'readwrite'); var store = tx.objectStore('manifests');
        var current = await requestResult(store.get(slot));
        if ((current ? current.manifest.generation : null) !== (expected || null)) { tx.abort(); try { await transactionDone(tx); } catch (_) {} return false; }
        store.put({ slot: slot, manifest: manifest });
        await transactionDone(tx); return true;
      },
      listManifests: async function () {
        var db = await open(); var tx = db.transaction('manifests', 'readonly'); var result = await requestResult(tx.objectStore('manifests').getAll());
        await transactionDone(tx); return result;
      },
      deleteManifest: async function (slot, generation) {
        var db = await open(); var tx = db.transaction('manifests', 'readwrite'); var store = tx.objectStore('manifests');
        var current = await requestResult(store.get(slot));
        if (current && current.manifest.generation === generation) store.delete(slot);
        await transactionDone(tx);
      },
      deleteGeneration: async function (slot, generation) {
        var db = await open(); var tx = db.transaction('pages', 'readwrite'); var store = tx.objectStore('pages');
        var range = IDBKeyRange.bound(slot + '|' + generation + '|', slot + '|' + generation + '|\uffff');
        var cursor = store.openCursor(range);
        cursor.onsuccess = function () { if (cursor.result) { cursor.result.delete(); cursor.result.continue(); } };
        await transactionDone(tx);
      },
      cleanupOrphans: async function (cutoff) {
        var live = new Set((await this.listManifests()).map(function (row) { return row.slot + '|' + row.manifest.generation + '|'; }));
        var db = await open(); var tx = db.transaction('pages', 'readwrite'); var store = tx.objectStore('pages');
        var cursor = store.openCursor();
        cursor.onsuccess = function () {
          if (!cursor.result) return;
          var row = cursor.result.value;
          if (row.createdAt < cutoff && !live.has(row.slot + '|' + row.generation + '|')) cursor.result.delete();
          cursor.result.continue();
        };
        await transactionDone(tx);
      },
      close: async function () { try { if (database) (await database).close(); } catch (_) {} finally { database = null; } }
    };
  }
  function create(options) {
    options = options || {};
    var context = String(options.contextKey || '');
    if (!context) throw new Error('Missing catalog context');
    var storage = options.sessionStorage;
    var browserDB = options.indexedDB;
    try { if (!storage) storage = globalThis.sessionStorage; } catch (_) { storage = null; }
    try { if (!browserDB) browserDB = globalThis.indexedDB; } catch (_) { browserDB = null; }
    var adapter = options.adapter || (browserDB ? idbAdapter(browserDB) : null);
    var now = options.now || Date.now;
    var sessionKey = 'q-catalog-search:session';
    var activeKey = 'q-catalog-search:active:' + context;
    var serialized = Promise.resolve();
    function slot(id) { return id + '|' + context + '|v' + VERSION; }
    function readSession() { try { return storage && storage.getItem(sessionKey); } catch (_) { return null; } }
    async function load() {
      if (!adapter) return null;
      var id = readSession();
      try { if (!id || !storage.getItem(activeKey)) return null; } catch (_) { return null; }
      if (adapter.cleanupOrphans) try { await adapter.cleanupOrphans(now() - 24 * 60 * 60 * 1000); } catch (_) {}
      try {
        var key = slot(id); var manifest = await adapter.readManifest(key);
        if (!manifest || manifest.status !== 'complete' || manifest.context !== context || manifest.schema !== VERSION || manifest.session !== id || !Number.isSafeInteger(manifest.pageCount) || manifest.pageCount < 1) return null;
        var entries = [];
        for (var i = 1; i <= manifest.pageCount; i++) {
          var value = await adapter.readPage(key, manifest.generation, i);
          if (!value) return null;
          entries.push(value);
        }
        if (!validate(entries)) return null;
        if (entries.reduce(function (total, entry) { return total + entry.products.length; }, 0) !== manifest.productCount) return null;
        return entries;
      } catch (_) { return null; }
    }
    function save(entries) {
      var task = serialized.catch(function () {}).then(async function () {
        if (!adapter || !validate(entries)) return { saved: false, reason: 'incomplete' };
        if (adapter.cleanupOrphans) try { await adapter.cleanupOrphans(now() - 24 * 60 * 60 * 1000); } catch (_) {}
        var id = readSession();
        try {
          if (!id) { id = uuid(); storage.setItem(sessionKey, id); }
          storage.setItem(activeKey, 'enabled');
        } catch (_) { return { saved: false, reason: 'storage' }; }
        var key = slot(id); var generation = uuid(); var previous;
        try {
          previous = await adapter.readManifest(key);
          var bytes = 0;
          for (var n = 0; n < entries.length; n++) {
            var compact = compactPage(entries[n]);
            bytes += JSON.stringify(compact).length * 2;
            if (bytes > MAX_SNAPSHOT) {
              await adapter.deleteGeneration(key, generation);
              return { saved: false, reason: 'limit' };
            }
            await adapter.writePage(key, generation, n + 1, compact);
          }
          var manifest = { session: id, context: context, schema: VERSION, generation: generation, status: 'complete', pageCount: entries.length,
            productCount: entries.reduce(function (sum, page) { return sum + page.products.length; }, 0), bytes: bytes, createdAt: now() };
          var committed = await adapter.commitManifest(key, previous && previous.generation, manifest);
          if (!committed) { await adapter.deleteGeneration(key, generation); return { saved: false, reason: 'stale' }; }
          try { storage.setItem(activeKey, generation); } catch (_) {}
          if (previous) try { await adapter.deleteGeneration(key, previous.generation); } catch (_) {}
          try {
            var all = (await adapter.listManifests()).filter(function (row) { return row.manifest && row.manifest.status === 'complete'; });
            all.sort(function (a, b) { return a.manifest.createdAt - b.manifest.createdAt; });
            var total = all.reduce(function (sum, row) { return sum + row.manifest.bytes; }, 0);
            while ((all.length > MAX_COUNT || total > MAX_TOTAL) && all.length > 1) {
              var oldest = all.shift();
              if (oldest.slot === key) { all.push(oldest); continue; }
              total -= oldest.manifest.bytes;
              await adapter.deleteManifest(oldest.slot, oldest.manifest.generation);
              await adapter.deleteGeneration(oldest.slot, oldest.manifest.generation);
            }
          } catch (_) {}
          return { saved: true };
        } catch (error) {
          try { await adapter.deleteGeneration(key, generation); } catch (_) {}
          return { saved: false, reason: error && error.name === 'QuotaExceededError' ? 'quota' : 'storage' };
        }
      });
      serialized = task;
      return task;
    }
    function invalidate() { try { if (storage) storage.removeItem(activeKey); } catch (_) {} return Promise.resolve(); }
    function close() { if (adapter && adapter.close) return adapter.close(); }
    return { load: load, save: save, invalidate: invalidate, close: close };
  }
  return { create: create, memoryAdapter: memoryAdapter, validate: validate };
});
